import { Component, inject, Input } from "@angular/core";
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { ProjectService } from "@domain/project/project.service";
import { UserService } from "@domain/user/user.service";
import { filter, map, Observable } from "rxjs";

interface Option {
  value: string;
  label: string;
}

@Component({
  selector: "app-checklist-item-multiple-choice",
  templateUrl: "./checklist-item-multiple-choice.component.html",
  styleUrls: ["./checklist-item-multiple-choice.component.scss"],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [UiKitModule, ReactiveFormsModule],
  standalone: true,
})
export class ChecklistItemMultipleChoiceComponent {
  private userService = inject(UserService);
  private projectService = inject(ProjectService);

  protected isReadOnlyUser$: Observable<boolean>;
  protected hasWritePermission$: Observable<boolean | undefined>;

  @Input()
  label!: string;

  @Input()
  subLabel!: string;

  @Input()
  groupName!: string;

  @Input()
  options!: Option[];

  @Input()
  disabled: boolean = true;

  constructor() {
    this.isReadOnlyUser$ = this.userService.user$.pipe(map((user) => user.readOnlyAccess));
    this.hasWritePermission$ = this.projectService.hasUserWritePermission$.pipe(
      filter((val): val is boolean => val !== undefined),
    );
  }
}
